module.exports = __webpack_public_path__ + "img/image_1-887dd55d.png";